module.exports = __webpack_public_path__ + "img/fedenko.e779ed87.jpg";